import { MIXPANEL_EVENT_NAMES, MIXPANEL_SOURCES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import useCameraPermissions from 'hooks/useCameraPermissions';
import i18n from 'i18n/config';
import { PossibleHypervergeKYCResultStatus } from 'types/hyperverge';
import Box from 'UIKit/Box';

import { DISABLE_2FA_FLOW } from './Disable2faFaceAuth.constants';
import styles from './disable2faFaceAuth.module.scss';
import { WorkflowData } from './Disable2faFaceAuth.types';
import { HypervergeFaceAuth } from './HyperVergeFaceAuth';
import { VerifyFaceAuthList } from './VerifyFaceAuthList/VerifyFaceAuthList';

const textVerifyIdentity = i18n.t('auth:twoFaFaceAuth.verifyIdentity');

const VerifyFaceAuth = ({
  workflowData,
  updateActiveFlow,
}: {
  workflowData: WorkflowData | null;
  updateActiveFlow: (flow: DISABLE_2FA_FLOW) => void;
}) => {
  useCameraPermissions({ askOnMount: true });

  const handleSdkResult = (result: PossibleHypervergeKYCResultStatus) => {
    if (result === 'auto_approved') {
      updateActiveFlow(DISABLE_2FA_FLOW.SDK_SUCCESS);
      return;
    }
    if (result === 'user_cancelled') {
      updateActiveFlow(DISABLE_2FA_FLOW.FACE_AUTH_FAILED);

      trackMixpanelEvent(
        MIXPANEL_EVENT_NAMES.DISABLE_2FA_WITH_FACE_AUTH.LOST_2FA_FACE_AUTH_STATUS,
        {
          status: 'cancelled',
          source: MIXPANEL_SOURCES.LOGIN_PAGE,
        }
      );
      return;
    }

    updateActiveFlow(DISABLE_2FA_FLOW.FACE_AUTH_REJECTED);

    trackMixpanelEvent(
      MIXPANEL_EVENT_NAMES.DISABLE_2FA_WITH_FACE_AUTH.LOST_2FA_FACE_AUTH_STATUS,
      {
        status: 'failed',
        source: MIXPANEL_SOURCES.LOGIN_PAGE,
      }
    );
  };

  const onSdkError = () => {
    updateActiveFlow(DISABLE_2FA_FLOW.FACE_AUTH_REJECTED);

    trackMixpanelEvent(
      MIXPANEL_EVENT_NAMES.DISABLE_2FA_WITH_FACE_AUTH.LOST_2FA_FACE_AUTH_STATUS,
      {
        status: 'error',
        source: MIXPANEL_SOURCES.LOGIN_PAGE,
      }
    );
  };

  return (
    <Box className={styles.verifyFaceAuthContainer}>
      <VerifyFaceAuthList />
      {workflowData && (
        <HypervergeFaceAuth
          className={styles.verifyFaceAuthBtn}
          text={textVerifyIdentity}
          workflowData={workflowData}
          onSdkFail={onSdkError}
          onSdkResult={handleSdkResult}
          onClickTracking={() => {
            trackMixpanelEvent(
              MIXPANEL_EVENT_NAMES.DISABLE_2FA_WITH_FACE_AUTH.FACE_AUTH_INITIATED,
              {
                source: MIXPANEL_SOURCES.LOGIN_PAGE,
              }
            );
          }}
        />
      )}
    </Box>
  );
};

export default VerifyFaceAuth;
